module.exports = __webpack_public_path__ + "media/app/assets/integrations/bnet_allow-100bd3e4b00a5966f2e37d731ae2ea88.png";